<template>
  <b-modal id="view_contact_modal" ref="view_contact_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="far fa-id-badge"></i>
          <span>Contact</span>
        </h1>
        <p id="mh-info" v-if="notEmptyObject(contact)">
          <span v-if="'contact_log_by' in contact"
                style="font-size: 0.65rem;">Last Updated : {{ contact.contact_log_by.first_name }} {{ contact.contact_log_by.surname }} on {{
              contact.updated_at | formatDateTime
            }}</span>
        </p>
      </div>
      <button id="mh-close" class="btn-close" v-on:click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row" v-if="notEmptyObject(contact)">
      <div class="col-3"><strong>Title:</strong></div>
      <div class="col-9" v-if="contact.person.title !== null && Object.keys(contact.person.title).length > 1">{{ contact.person.title.value }}</div>
      <div class="col-9" v-else></div>
      <div class="col-3"><strong>First Name:</strong></div>
      <div class="col-9">{{ contact.person.first_name }}</div>
      <div class="col-3"><strong>Surname:</strong></div>
      <div class="col-9">{{ contact.person.surname }}</div>
      <div class="col-3"><strong>Job Title:</strong></div>
      <div class="col-9" v-if="contact.rel_profile.job_title_id !== null">{{ contact.rel_profile.job_title.job_title }}</div>
      <div class="col-9" v-else></div>
      <div class="col-12">
        <hr>
      </div>
      <div class="col-3"><strong>Personal Landline:</strong></div>
      <div class="col-9">{{ contact.phones.personal_landline }}</div>
      <div class="col-3"><strong>Personal Mobile:</strong></div>
      <div class="col-9">{{ contact.phones.personal_mobile }}</div>
      <div class="col-3"><strong>Personal Email:</strong></div>
      <div class="col-9">{{ contact.emails.personal_email }}</div>
      <div class="col-12">
        <hr>
      </div>
      <div class="col-3"><strong>Work Landline:</strong></div>
      <div class="col-9">{{ contact.phones.work_landline }}</div>
      <div class="col-3"><strong>Work Mobile:</strong></div>
      <div class="col-9">{{ contact.phones.work_mobile }}</div>
      <div class="col-3"><strong>Work Email:</strong></div>
      <div class="col-9">{{ contact.emails.work_email }}</div>
    </div>

    <div class="row mt-4" v-if="!$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
      <div class="col-md-4">
        <button v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))"
                class="btn orcaBtn danger" data-toggle="tooltip" title="Delete Contact" @click.prevent="deleteContact">Delete
        </button>
      </div>
      <div class="col-md-4">
        <button class="btn orcaBtn greenBtn" data-toggle="tooltip" title="Edit Contact" @click.prevent="editContact">Edit</button>
      </div>
      <div class="col-md-4">
        <button class="btn orcaBtn" data-toggle="tooltip" title="View Contact Profile" @click.prevent="profileContact">Profile</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "view_contact",
  data() {
    return {
      contact: {}
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'contact/' + this.$store.state.contacts.modal.contact_id).then(contact => this.contact = contact.data);
  },
  methods: {
    hideModal() {
      this.$refs.view_contact_modal.hide();
      this.$store.commit('HIDE_CONTACT_MODAL');
    },
    deleteContact() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Contact</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to delete:<br>' + this.contact.person.first_name + ' ' + this.contact.person.surname +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$store.commit('SET_DELETE_CONTACT_ID', this.contact.id);

              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'contact/' + this.contact.id, {
                params: {
                  // Set log values (current crm user)
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$nextTick(() => {
                  this.$bus.$emit('table::reload', {table: 'client_contacts', type: 'delete'});
                  this.$bus.$emit('table::reload', {table: 'all_contacts', type: 'delete'});
                  this.$bus.$emit('contacts::reload', {action: true});
                  this.$bus.$emit('logs::reload', {action: true});
                  this.hideModal()
                })
              });
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    editContact() {
      this.$store.commit('SHOW_EDIT_CONTACT_MODAL', {
        contact_id: this.contact.id,
        company_id: this.contact.company_id,
        row_node_id: this.$store.state.contacts.modal.row_node_id
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_contact_modal'))
    },
    profileContact() {
      this.$store.commit('CURRENT_PROFILE_CONTACT_ID', this.contact.id);
      this.$nextTick(() => {
        this.hideModal();
        this.$router.push('/contact/profile');
        this.$tabs.refresh('/contact/profile', true);
      })
    }
  }
}
</script>

<style scoped lang="scss">
#view_contact_modal {
  #mh-info {
    span {
      display: block;
      width: 100%;
      line-height: 0.9rem;
    }
  }
}
</style>
